import qs from 'qs';
import request from '@/config/request';

/*
  获取审核列表
  userName,userPhone
*/
export function getSmallTicketList({ page, pageSize, ...rest }) {
  return request({
    url: `/smallTicket/getSmallTicketList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  订单生成
  userId, orderId,shopName,ticketIntegral,buyTime,products
*/
export function addBuyRecord(rest) {
  return request({
    url: '/smallTicket/addBuyRecord',
    method: 'post',
    data: rest,
  });
}

/*
  拒绝
  id,refuseInfo
*/
export function refuseSmallTicket(rest) {
  return request({
    url: '/smallTicket/refuseSmallTicket',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取小票信息
  id
*/
export function getSmallTicket(id) {
  return request({
    url: '/smallTicket/getSmallTicket',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  店员上传小票
  userId, userName，userPhone，shopId，shopName，ticketUrl
*/
export function addSmallTicket(rest) {
  return request({
    url: '/smallTicket/addSmallTicket',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  查询会员列表
  userPhone
*/
export function getShopUserList(rest) {
  return request({
    url: '/smallTicket/getShopUserList',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  查询店铺列表
  shopName
*/
export function getAppShopList(rest) {
  return request({
    url: '/smallTicket/getAppShopList',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  查询配件雪茄名称
  name
*/
export function getCigarOrBoutique(name) {
  return request({
    url: '/smallTicket/getCigarOrBoutique',
    method: 'post',
    data: qs.stringify({ name }),
  });
}
